const About = () => {
  return (
    <div>
      {/* Mission Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold mb-6">Our Mission</h1>
            <p className="text-xl text-gray-600 mb-8">
              At HalfTheSky, we're dedicated to empowering women in technology
              through education, mentorship, and community support. We believe
              that by providing equal opportunities and resources, we can help
              bridge the gender gap in the tech industry.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Value 1 */}
            <div className="text-center p-6">
              <h3 className="text-xl font-bold mb-4">Inclusivity</h3>
              <p className="text-gray-600">
                We create an inclusive environment where everyone feels welcome
                and valued.
              </p>
            </div>

            {/* Value 2 */}
            <div className="text-center p-6">
              <h3 className="text-xl font-bold mb-4">Excellence</h3>
              <p className="text-gray-600">
                We strive for excellence in everything we do, from education to
                community support.
              </p>
            </div>

            {/* Value 3 */}
            <div className="text-center p-6">
              <h3 className="text-xl font-bold mb-4">Innovation</h3>
              <p className="text-gray-600">
                We embrace innovation and encourage creative thinking in solving
                challenges.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Our Team</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Team Member 1 */}
            <div className="text-center">
              <div className="w-48 h-48 rounded-full bg-gray-200 mx-auto mb-4"></div>
              <h3 className="text-xl font-bold mb-2">Jane Doe</h3>
              <p className="text-gray-600 mb-2">Founder & CEO</p>
              <p className="text-sm text-gray-500">
                Passionate about technology and gender equality.
              </p>
            </div>

            {/* Team Member 2 */}
            <div className="text-center">
              <div className="w-48 h-48 rounded-full bg-gray-200 mx-auto mb-4"></div>
              <h3 className="text-xl font-bold mb-2">Sarah Smith</h3>
              <p className="text-gray-600 mb-2">Education Director</p>
              <p className="text-sm text-gray-500">
                Dedicated to creating impactful learning experiences.
              </p>
            </div>

            {/* Team Member 3 */}
            <div className="text-center">
              <div className="w-48 h-48 rounded-full bg-gray-200 mx-auto mb-4"></div>
              <h3 className="text-xl font-bold mb-2">Emily Johnson</h3>
              <p className="text-gray-600 mb-2">Community Manager</p>
              <p className="text-sm text-gray-500">
                Building strong, supportive tech communities.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 